import axios from 'axios'
const errorsHandler = require('@/services/errors')

const moduleName = 'sport-master-config'

const state = {}

const getters = {}

const actions = {
    // LISTA COMPLETA CONFIG (per index admin)
    index: async (context, payload) => {
        let url = `api/v1/${moduleName}`

        // payload opzionale per filtri (es. { active: true })
        const params = payload || {}

        return axios
            .get(`${context.rootGetters['settings/getEndpoint']}${url}`, {
                headers: {
                    Authorization: `Bearer ${context.rootGetters['user/getUser'].token}`
                },
                params,
                'Content-Type': 'application/json'
            })
            .then(result => {
                // backend: { success: true, result: [...] }
                return result.data.result
            })
            .catch(error => {
                return errorsHandler.errorHandler(error)
            })
    },

    // SOLO LISTA MASTER ATTIVI (per select in sports create/edit)
    getMasters: async (context) => {
        let url = `api/v1/${moduleName}/masters`

        return axios
            .get(`${context.rootGetters['settings/getEndpoint']}${url}`, {
                headers: {
                    Authorization: `Bearer ${context.rootGetters['user/getUser'].token}`
                },
                'Content-Type': 'application/json'
            })
            .then(result => {
                // backend: { success: true, result: ['calcio','basket',...] }
                return result.data.result
            })
            .catch(error => {
                return errorsHandler.errorHandler(error)
            })
    },

    // CREATE
    store: async (context, payload) => {
        let url = `api/v1/${moduleName}/store`

        return axios
            .post(
                `${context.rootGetters['settings/getEndpoint']}${url}`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${context.rootGetters['user/getUser'].token}`
                    },
                    'Content-Type': 'application/json'
                }
            )
            .then(result => {
                return {
                    success: true,
                    result: result.data
                }
            })
            .catch(error => {
                return errorsHandler.errorHandler(error)
            })
    },

    // READ SINGLE
    edit: async (context, payload) => {
        let url = `api/v1/${moduleName}/${payload.id}`

        return axios
            .get(`${context.rootGetters['settings/getEndpoint']}${url}`, {
                headers: {
                    Authorization: `Bearer ${context.rootGetters['user/getUser'].token}`
                },
                'Content-Type': 'application/json'
            })
            .then(result => {
                // backend: { success: true, result: {...} }
                return result.data
            })
            .catch(error => {
                return errorsHandler.errorHandler(error)
            })
    },

    // UPDATE
    update: async (context, payload) => {
        let url = `api/v1/${moduleName}/update/${payload.id}`

        return axios
            .post(
                `${context.rootGetters['settings/getEndpoint']}${url}`,
                payload.item,
                {
                    headers: {
                        Authorization: `Bearer ${context.rootGetters['user/getUser'].token}`
                    },
                    'Content-Type': 'application/json'
                }
            )
            .then(result => {
                return {
                    success: true,
                    result: result.data
                }
            })
            .catch(error => {
                return errorsHandler.errorHandler(error)
            })
    },

    // DELETE
    delete: async (context, payload) => {
        let url = `api/v1/${moduleName}/delete/${payload.id}`

        return axios
            .post(
                `${context.rootGetters['settings/getEndpoint']}${url}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${context.rootGetters['user/getUser'].token}`
                    },
                    'Content-Type': 'application/json'
                }
            )
            .then(result => {
                return {
                    success: true,
                    result: result.data
                }
            })
            .catch(error => {
                return errorsHandler.errorHandler(error)
            })
    },

    // MASS DELETE (se ti serve anche qui)
    massDelete: async (context, payload) => {
        let url = `api/v1/${moduleName}/mass-delete`

        return axios
            .post(
                `${context.rootGetters['settings/getEndpoint']}${url}`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${context.rootGetters['user/getUser'].token}`
                    },
                    'Content-Type': 'application/json'
                }
            )
            .then(result => {
                return {
                    success: true,
                    result: result.data
                }
            })
            .catch(error => {
                return errorsHandler.errorHandler(error)
            })
    }
}

const mutations = {}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
